/**
 * Human-readable Member price for Pricing / CTAs.
 * Hardcoded on purpose — Stripe price ids belong only in STRIPE_PRICE_ID (Netlify functions).
 * Do not wire REACT_APP_* to Stripe ids; that is what made the UI show "price_1…".
 */
export const SUBSCRIPTION_PRICE = "$10/month";
/** @deprecated Annual plan is no longer offered to new signups — kept only for existing yearly members. */
export const ANNUAL_SUBSCRIPTION_PRICE = "$79/year";

export const MEMBER_TRIAL_DAYS = 14;

export const TEAMS_CONTACT_EMAIL = "pritisolanki@ahavibes.xyz";

export const PRICING_PORTABILITY_NOTE =
  "Your reflections remain yours — export anytime, on any plan.";

export const PRICING_TRIAL_NOTE =
  "14-day free trial. Card required; billing starts on day 15 unless you cancel.";

export const PRICING_MEMBER_PRICE_SUMMARY = SUBSCRIPTION_PRICE;

export const MEMBER_COACHING_SESSION_FEATURE = "Complimentary 1:1 onboarding session with the founder";

/** Free tier: total AI insight entries (logged-in brain dump + saved reflections with insight). */
export const FREE_AI_INSIGHTS_TOTAL = 21;

export const FREE_HISTORY_VISIBLE = 3;

export const FREE_MAX_WORDS_PER_ENTRY = 500;

export const PRICING_INTRO =
  "Ahavibes is freemium: start with the full thinking framework for free, then upgrade when you want unlimited insights and deeper pattern intelligence from your reflection history.";

export const PRICING_GROWTH_NOTE =
  "Both plans use the same Event → Interpretation → Evidence → Response flow. Free helps you practice clear thinking; Member helps you see what repeats so you can change it.";

export const PRICING_TIERS = {
  free: {
    id: "free",
    name: "Free",
    price: "$0",
    period: "to start",
    tagline: "Build the thinking habit",
    cta: "Start reflecting",
    ctaTo: "/",
    features: [
      "Verifiable email required to examine thoughts with AI",
      `Up to ${FREE_AI_INSIGHTS_TOTAL} AI insights total when signed in`,
      `Last ${FREE_HISTORY_VISIBLE} Quick Clarity sessions visible in Past Reflections (legacy reflections listed separately)`,
      "Cognitive Behavioral Patterns hub — emotions, reports, mental load summary, and pattern counts (full breakdowns locked)",
      "Export your reflections as JSON anytime",
      `${FREE_MAX_WORDS_PER_ENTRY} words max per Quick Clarity entry`,
      "Opt out of non-essential product emails anytime; delete your account from Profile"
    ],
    helps: [
      "Practice separating facts from stories",
      "Build a daily reflection rhythm without pressure",
      "See if structured thinking fits your life"
    ]
  },
  member: {
    id: "member",
    name: "Member",
    price: SUBSCRIPTION_PRICE.replace(/\/month$/i, ""),
    period: "per month",
    tagline: "Build pattern intelligence",
    cta: "Become a member",
    features: [
      "Unlimited AI insights and brain-dump sessions",
      "See repeating loops, recurring interpretations, and full pattern breakdowns",
      "Full reflection history — nothing trimmed",
      "Cognitive Behavioral Patterns dashboard on full history — emotions, stress, anger, and mental load trends",
      "14-day free trial, then billed monthly",
      MEMBER_COACHING_SESSION_FEATURE,
      "Export your reflections as JSON anytime",
      "Priority access to new reflection tools"
    ],
    helps: [
      "Spot overthinking, stress, and anger patterns before they run you",
      "Turn one-off clarity into long-term self-understanding",
      "Make better decisions with evidence, not emotional loops"
    ]
  }
};

export function getMemberDisplayPrice() {
  return {
    amount: SUBSCRIPTION_PRICE.replace(/\/month$/i, ""),
    period: "per month"
  };
}

export function getTeamsContactHref() {
  return `mailto:${TEAMS_CONTACT_EMAIL}?subject=${encodeURIComponent("Teams inquiry")}`;
}
